<template>
<div>
  <div class="drawer-btn">
    <button class="hvr btn-menu hvr-scale pa-1" @click="atribuciones=true"><img src="../assets/imagenes_compartidas/Menu_Interfaz_basica/Creditos.svg" alt="Créditos"></button>
    <button class="hvr btn-menu hvr-scale pa-1" @click="glosario=true"><img src="../assets/imagenes_compartidas/Menu_Interfaz_basica/Glosario.svg" alt="Glosario"></button>
    <button class="hvr btn-menu hvr-scale menu-btn" @click="drawer = !drawer">
      <img src="../assets/imagenes_compartidas/Menu_Interfaz_basica/Menu_unidad.svg">
    </button>
    <button class="hvr btn-menu hvr-scale pa-1" @click="cibergrafia=true"><img src="../assets/imagenes_compartidas/Menu_Interfaz_basica/Abecedario.svg" alt="Cibergrafía"></button>
    <button class="hvr btn-menu hvr-scale pa-1" @click="ajustes=true"><img src="../assets/imagenes_compartidas/Menu_Interfaz_basica/Ajustes.svg" alt="Ajustestes"></button>
  </div>
  <v-navigation-drawer id="list-container" width="600px" bottom="true" v-model="drawer" temporary absolute class="drawer">
    <v-toolbar flat class="title">
      <v-list>
        <h1 class="nav-title">
          Unidade 1
        </h1>
        <!-- <v-list-tile>
          <v-list-tile-title>

          </v-list-tile-title>
        </v-list-tile> -->
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>

    <v-list class="course-menu" v-resize="adjustButtons">
      <template v-for="(menubot, indexUl) in data.menubots">
        <template v-if="menubot.subt.length == 0">
          <v-list-tile class="menu-tile" v-if="conteoPags >= calculateNumberOfPages(0) + menubot.pages[0]" 
            @click.native="clickNav, hideNav(indexUl), goTo(menubot.link)" 
            :class="{'active':menubot.active}" :key="'tile'+indexUl">
            {{menubot.name}}
          </v-list-tile>
        </template>
        <template v-else>
          <v-list-group :value="menubot.active" class="menu-tile" 
          v-if="conteoPags >= calculateNumberOfPages(0) + menubot.pages[0]" :key="'tile'+indexUl">
            <v-list-tile  @click.native="clickNav, hideNav(indexUl), goTo(menubot.link)" 
            class="tema" :class="{'active':menubot.active}"  slot="activator">
              {{menubot.name}}
            </v-list-tile>
<!-- v-if="(submenu.pages[0] + calculateNumberOfPages(0)) <= conteoPags" -->
            <v-list-tile class="submenu-tile" @click="goTo(submenu.link)" 
            v-for="(submenu, index) in menubot.subt" :key="'subt'+indexUl+index">
              {{submenu.name}}
            </v-list-tile>
          </v-list-group>
        </template>
      </template>
    </v-list>

  </v-navigation-drawer>
  <modal-app v-model="atribuciones" :fullscreen="true"> 
      <template slot="modaltittle">
        <h1 class="modal-icon-title">
          Atribuições
        </h1>
      </template>
  </modal-app>
  <modal-app v-model="glosario" :fullscreen="true"> 
      <template slot="modaltittle">
        <h1 class="modal-icon-title">
          Glosário
        </h1>
      </template>
  </modal-app>

  <modal-app v-model="cibergrafia" :fullscreen="true"> 
      <template slot="modaltittle">
        <h1 class="modal-icon-title">
          Cibergrafia
        </h1>
      </template>
  </modal-app>
  <modal-app v-model="ajustes" :fullscreen="true"> 
      <template slot="modaltittle">
        <h1 class="modal-icon-title">
          Ajustes
        </h1>
      </template>
  </modal-app>

</div>
</template>
<script>
import resourcesLoader from '../js/mixins/resources-loader'
import scormmixins from '../js/mixins/scormmixins'
// import Glosario from '../components/glosario'
import resize from 'vue-resize-directive'
// import Creditos from '../components/creditos'

export default {
  directives: {
      resize,
  },
  components: {
    // Glosario,
    // Creditos
  },
  mixins: [resourcesLoader,scormmixins],
  data() {
    return {
      data: '',
      atribuciones: false,
      glosario: false,
      cibergrafia: false,
      ajustes:false,
      materialReferencia: false,
      materialReferencia: false,
      drawer: false,
      cibergrafiaData: [],
      referencias: [],
      listHeightScroll: false,
      titulo: ''
    }
  },
  created() {
    var self = this
    // this.referencias = this.requireJson('material-referencia');
    // this.cibergrafiaData = this.requireJson('cibergrafia');
    this.getJson('modulos/navegacion', data => {
      self.data = data
      self.calculateNumberOfPages()
    })
    // this.getJson('textos_proyecto',function(data){
    //   self.titulo = data.nombre_del_proyecto
    // })
  },
  methods: {
    adjustButtons() {
      var list = document.querySelector('.course-menu')
      var listContainer = document.getElementById('list-container')
      console.log('lch: '+listContainer.clientHeight + ' lh: '+list.offsetHeight)
      this.listHeightScroll= listContainer.clientHeight - 283 < list.offsetHeight;
    },
    hey(modNum) {
      var canTemas = 0
      for(var i = 0; i < modNum; i++) {
        canTemas += this.data.menubots[i].canTemas
      }
      return canTemas
    },

    clickNav() {
      var routeArr = this.$route.path.split("/");
      var modName = routeArr[routeArr.length - 2];
      var pageNum = routeArr[routeArr.length - 1];

      this.data.menubots.forEach(function(element) {
        var botName = element.link.split("/");
        // Actualiza nombre en el encabezado
        if(pageNum >= element.pages[0] && pageNum <= element.pages[1]){
          this.$store.commit('temaName', element.name)
          console.log(this.$store.state.tema)
        }
        // Muestra los temas que se han visitado y oculta los temas futuros
        if (element.link === this.$route.path) {
          } else if (modName === botName[1]) {
            // this.$store.commit('temaName', element.name)
          element.active = true;
        } else {
          element.active = false;
        }

        // Muestra los subtemas
        element.subt.forEach(function(subElem) {
          var subLink = subElem.link.split("/")
          if (subLink[1] === modName && (pageNum >= subElem.pages[0] && pageNum <= subElem.pages[1])) {
            this.$store.commit('subTemaName', subElem.name)
            this.$store.commit('temaName', element.name)
            subElem.active = true;
          } else {
            subElem.active = false;
          }
        }, this)
      }, this);
    },
    hideNav(event) {
      if (this.data.menubots[event].subt.length === 0) {
        this.navshow = false;
      }
    },
    calculateNumberOfPages(modNum) {
      return this.$store.getters.globalPage(modNum)
    },
    goTo(route){
      this.$router.push(route)
    }
  },
  watch: {
    '$route' (to, from) {
      this.clickNav();
    }
  },
  mounted() {
    this.clickNav();
  },
}
</script>
<style lang="scss" scoped>
@import '../sass/globals';

// CONTENEDOR MENU
.drawer {
  font-family: Poppins-Bold;
  color: black;
  a {
    color: black;
    text-decoration: none;
  }
  //   Elimina la margen para celulares y cambia el tamaño para no hacer overlap con la barra
  @media (max-width: 600px) {
      margin-left: 0;
      height: calc(100% - 40px) !important;
  }
}

.menu-tile {
  border-bottom: 1px solid #000C1A;
  cursor: pointer;
  font-family: Poppins-regular;
  transition: all 0.3s ease-out!important;
  &:hover{
    // background: $ibra-dark-blue!important;
    // color: white;
    font-size: 4px!important;
  }
}

.submenu-tile {
  border-bottom: 1px solid #000C1A;
  margin: 5px;
  margin-left: 1em;
  background-color: white;
  font-family: Poppins-Regular;
  transition: all 0.3s ease-out!important;
    &:hover{
    background: $ibra-dark-blue!important;
    color: white;
    font-size: 4px!important;
  }
}

// Esta es la barra vertical
.drawer-btn{
  bottom: 0;
  position: fixed;
  left: 0;
  width: 100%;
  height: 40px;
  background: url('../assets/imagenes_compartidas/Fondo_Menu_inferior_optimo.svg')50% no-repeat;
  background-size: cover;
  z-index: 7;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-menu{
  width: 40px;
  height: 40px;
  margin: 0px 8px;
  img{
    width: 40px;
  }
}

.title {
  background: white;
  .nav-title{
    max-width: 270px;
    color: $ibra-dark-blue!important;
    margin: 0 auto;
    word-break:normal;
    font-family: Poppins-BoldItalic;
    font-size: 20px;
    text-align: center;
  }
}

.bottom-buttons {
  position: absolute;
  bottom: 5px;
  padding: 1px;
  width: 100%;
  background-color: white;
  img {
    width: 50px;
  }
  .footer-img {
    display: block;
    width: 100%;
    height: auto;
    opacity: 1;
    position: static;
    background-color: white;
    padding: 10px;
  }
}

.bottom-buttons-static {
  position: static;
}

// .creditos {
//   .logo-dom{
//     display: block;
//     width: 300px;
//     margin-bottom: 1rem;
//   }
//   h2 {
//     margin-top: 1.5rem;
//   }
// }

.modal-icon-title{
  color: $ibra-dark-blue;
}
</style>
